import styled from "styled-components";

const StyledSkillsCard = styled.article`
  display: flex;
  margin-top: 1rem;
  margin-bottom: 1rem;
  flex-direction: column;

  .skills_card-header {
    display: flex;
    padding: 1rem;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    flex: 0 1 19rem;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    background-color: #007bff;
    background-image: -webkit-gradient(linear, left top, left bottom, from(#007bff), color-stop(98%, #c2c690), to(#ffffe0));
    background-image: linear-gradient(180deg, #007bff, #c2c690 98%, #ffffe0);
  }
  
  @media screen and (max-width: 479px) {
    .skills_card-header {
      flex-basis: 16rem;
    }
  }

  .skills_card-body {
    display: flex;
    padding: 1rem;
    flex-direction: column;
    align-items: stretch;
    flex: 1 1 auto;
    border-right: 1px solid rgba(0, 0, 0, 0.13);
    border-bottom: 1px solid rgba(0, 0, 0, 0.13);
    border-left: 1px solid rgba(0, 0, 0, 0.13);
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    background-color: #f5f7fa;
  }

  .skills_card-icon {
    font-family: 'Font Awesome 6 Free', sans-serif;
    font-size: 11rem;
    line-height: 1;
  }
 
  .skills_card-title {
    color: #fff;
    font-size: 1.75rem;
    line-height: 1;
    text-align: center;
  }

  @media screen and (max-width: 479px) {
    .skills_card-icon {
      font-size: 9rem;
    }
    
    .skills_card-title {
      font-size: 1.5rem;
    }
  }

  .skills_card-body {
    display: flex;
    padding: 1rem;
    flex-direction: column;
    align-items: stretch;
    flex: 1 1 auto;
    border-right: 1px solid rgba(0, 0, 0, 0.13);
    border-bottom: 1px solid rgba(0, 0, 0, 0.13);
    border-left: 1px solid rgba(0, 0, 0, 0.13);
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    background-color: #f5f7fa;
  }

 

`

export default StyledSkillsCard;